// src/app/core/services/etag.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EtagService {
  public etagChanged$ = new Subject<void>();
  notifyEtagChanged() {
    this.etagChanged$.next();
  }
}
